import { getRecoil, setRecoil } from "recoil-nexus";
import participantsState from "../../atoms/participants";
import { socket } from "../index";

const emitJoinRoom = (
  roomId: string,
  password: string,
) => {
  const participants = getRecoil(participantsState);
  setRecoil(participantsState, {
    ...participants,
    roomId,
  });

  socket?.emit('JOIN_ROOM', {
    roomId,
    password,
  });
}

export default emitJoinRoom;